import { IPersonBadge } from "../../../../../../../common/types";

const areBadgesNotTheSame = (
  prev: IPersonBadge,
  current: IPersonBadge,
  currentEntitlement: string | undefined,
  prevEntitlement?: string
) => {
  if (!prev.contact && !current.contact) {
    return true;
  }
  const { contact: prevContact, customerType: prevCustomerType } = prev;
  const { contact: currentContact } = current;
  const hasNameBeenChanged = prevContact.firstName !== currentContact.firstName || prevContact.lastName !== currentContact.lastName;
  const hasEntitlementBeenChanged = currentEntitlement && prevEntitlement && currentEntitlement !== prevEntitlement;
  return (
    hasNameBeenChanged ||
    prevContact.jobTitle !== currentContact.jobTitle ||
    prevCustomerType !== current.customerType ||
    hasEntitlementBeenChanged ||
    current.badgeVersion !== prev.badgeVersion
  );
};

const GenerateBadgeUtils = { areBadgesNotTheSame };

export default GenerateBadgeUtils;
